import { Link, useSearchParams } from "react-router-dom";
import Title from "../components/ui/Title";
import { Button } from "../components/ui/button";
import { useEffect } from "react";
import axiosClient from "../lib/axiosClient";
import Box from "../components/ui/Box";

const SuccessPage = () => {
  const [params] = useSearchParams();
  const type = params.get("type");
  const sessionId = params.get("session_id");

  useEffect(() => {
    const updateFacture = async () => {
      try {
        if (sessionId) {
          await axiosClient.post(`/paiement/valider-paiement-session`, {
            sessionId,
          });
          return { props: { success: true } };
        } else {
          throw "Cette session n'existe pas.";
        }
      } catch (error) {
        return { props: { success: false } };
      }
    };
    updateFacture();
  }, []);

  return (
    <Box className="text-center mt-2 md:mt-8">
      {/* Carte bancaire */}
      {type === "cb" && (
        <>
          <Title>Paiement validé</Title>
          <div className="my-8">
            Votre paiement a été accepté. Merci pour votre confiance.
          </div>
        </>
      )}
      {/* Virement */}
      {type === "vir" && (
        <>
          <Title>Commande reçue</Title>
          <div className="mt-8 mb-2">
            Votre demande d'abonnement a bien été reçue. Une facture vient de
            vous être envoyée par email.
          </div>
          <div className="mb-8">
            Pour activer votre abonnement, veuillez vous acquitter du paiement
            de la facture par virement à l'IBAN suivant:
            <br />
            <strong className="my-1 block">
              FR38 3000 2004 3800 0000 7191 U50
            </strong>
            Pensez également à indiquer le numéro de facture en référence.
          </div>
        </>
      )}
      {/* Chèque */}
      {type === "chq" && (
        <>
          <Title>Commande reçue</Title>
          <div className="mt-8 mb-2">
            Votre demande d'abonnement a bien été reçue. Une facture vient de
            vous être envoyée par email.
          </div>
          <div className="mb-8">
            Pour activer votre abonnement, veuillez vous acquitter du paiement
            de la facture par chèque, à l'ordre de{" "}
            <strong>
              L'Abeille de France.
              <br />5 rue de Copenhague
              <br />
              75008 Paris
            </strong>
            <br />
            Pensez également à indiquer le numéro de facture au dos du chèque.
          </div>
        </>
      )}

      {/* Bouton */}
      <Link to="/" replace>
        <Button>Retour à l'accueil</Button>
      </Link>
    </Box>
  );
};

export default SuccessPage;
